import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

// Utils
import {
  createFeedback,
  getFeedbackById,
  updateFeedback,
  uploadMedia,
} from 'app/api/feedback';
import {
  feedbackValidationRules,
  validate,
} from 'app/constants/validation-constants';
import Message from 'app/utils/Message';
import Toast from 'app/utils/Toast';
import { APP_CONSTANTS } from 'app/constants/app-constants';

const useCreateFeedback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [pageLoading, setPageLoading] = useState(false);

  const [error, setErrors] = useState({});
  const [values, setValues] = useState({
    title: '',
    headline: '',
    description: '',
    docUrl: '',
    daysVisibleOnHomeScreen: null,
    image: null,
    startDate: '',
    expiredDate: '',
    status: true,
  });

  const feedbackId = location?.state?.id ? location?.state?.id : '';

  useEffect(() => {
    if (feedbackId) {
      loadStoreData(feedbackId);
    }
  }, []);

  const loadStoreData = async (id) => {
    if (!id) {
      return;
    }

    setPageLoading(true);
    let response = await getFeedbackById(id);
    setPageLoading(false);
    if (response?.responseCode === 200) {
      let responsedata = response?.data;
      setValues((prevState) => ({
        ...prevState,
        title: responsedata?.title,
        headline: responsedata?.headline,
        description: responsedata?.description,
        docUrl: responsedata?.docUrl,
        daysVisibleOnHomeScreen: responsedata?.daysVisibleOnHomeScreen,
        image: responsedata?.image,
        startDate: responsedata?.startDate,
        expiredDate: responsedata?.expiredDate,
        status: responsedata?.status,
      }));
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  };

  const callAddOrUpdateAPI = async () => {
    setPageLoading(true);
    let response = {};

    let senddata = {
      ...values,
    };

    if (feedbackId) {
      response = await updateFeedback(feedbackId, { ...senddata });
    } else {
      response = await createFeedback({ ...senddata });
    }
    setPageLoading(false);
    if (response?.responseCode === 200) {
      Toast.success(
        feedbackId
          ? Message.Feedback.UPDATED_SUCCESS
          : Message.Feedback.CREATED_SUCCESS
      );

      navigate(-1);
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  };

  const handleCreateFeedback = (e) => {
    e.preventDefault();
    const validationErrors = validate(values, feedbackValidationRules);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      callAddOrUpdateAPI();
    } else {
      console.log(validationErrors);
    }
  };

  const handleChange = (e) => {
    if (e && e.target) {
      const { name, value } = e.target;
      setValues({
        ...values,
        [name]: name === 'daysVisibleOnHomeScreen' ? parseInt(value) : value,
      });

      if (error[name]) {
        setErrors({
          ...error,
          [name]: '',
        });
      }
    }
  };

  const setChange = (name, val) => {
    setValues((prevState) => ({
      ...prevState,
      [name]: val,
    }));
    setErrors({
      ...error,
      [name]: '',
    });
  };

  const uploadMediaHandler = async (file, name) => {
    if (!file) {
      // If the file is null, it means the user clicked the remove button
      setChange(name, null);
      return;
    }

    const response = await uploadMedia(file);
    if (response.responseCode === 200) {
      Toast.success('Image upload Successfull');

      const data = await response.data;
      setChange(name, data?.url);
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  };

  return {
    handleChange,
    values,
    error,
    setValues,
    handleCreateFeedback,
    pageLoading,
    feedbackId,
    uploadMediaHandler,
    navigate,
    setChange,
  };
};

export default useCreateFeedback;
